import React from "react";

const Footer = () => {
  return (
    <footer className="page-footer white center-align" style={{backgroundColor: '#262626'}}>
  <p className="grey-text">COPYRIGHT © SAVESTEPS 2018</p>
</footer>
  );
};
export default Footer;